import React, { useState } from 'react';
import { onaylaCihazDegisimi, iptalCihazDegisimi } from '../services/cihazDegisimiService';
import { toValidObjectIdString } from '../utils/security';
import './CihazDegisimiOnaylaModal.css';

const getErrorMessage = (error, fallback) => {
  if (!error) return fallback;
  const msg = error?.message || error?.data?.mesaj || error?.data?.message || fallback;
  return msg === 'Failed to fetch' ? 'Sunucuya bağlanılamadı' : msg;
};

const CihazDegisimiOnaylaModal = ({ cihazDegisimi, onClose, onSuccess }) => {
  const [action, setAction] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!cihazDegisimi) return null;

  const id = toValidObjectIdString(cihazDegisimi.id ?? cihazDegisimi._id);

  const handleConfirm = async () => {
    if (!action || !id) {
      setError(id ? 'Lütfen bir işlem seçin' : 'Geçersiz kayıt ID\'si');
      return;
    }

    setError('');
    setLoading(true);
    try {
      const fn = action === 'onayla' ? onaylaCihazDegisimi : iptalCihazDegisimi;
      const response = await fn(id);
      if (response?.basarili) {
        window.showNotification?.('success', response?.mesaj || (action === 'onayla' ? 'Onaylandı' : 'İptal edildi'));
        onSuccess?.();
      } else {
        setError(response?.mesaj || 'İşlem başarısız');
      }
    } catch (err) {
      setError(getErrorMessage(err, 'İşlem sırasında hata oluştu'));
    } finally {
      setLoading(false);
    }
  };

  const handleActionSelect = (a) => {
    setAction(a);
    setError('');
  };

  return (
    <div className="modal-overlay cihaz-degisimi-onayla-modal" onClick={onClose}>
      <div className="modal-content cihaz-onayla-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="cihaz-onayla-modal-header">
          <div className="cihaz-onayla-icon-wrap">
            <i className="fas fa-clipboard-check"></i>
          </div>
          <h2>Cihaz Değişimi İşlemi</h2>
          <p className="cihaz-onayla-subtitle">{cihazDegisimi.cihazDegisimiNumarasi}</p>
        </div>
        <div className="cihaz-onayla-modal-body">
          <p className="cihaz-onayla-desc">
            Bu talebi onaylayarak cihazı iade kargolarına ekleyebilir veya talebi iptal edebilirsiniz.
          </p>

          {!action ? (
            <div className="cihaz-onayla-action-buttons">
              <button
                type="button"
                className="cihaz-onayla-action-btn cihaz-onayla-btn-approve"
                onClick={() => handleActionSelect('onayla')}
                disabled={loading}
              >
                <i className="fas fa-check-circle"></i>
                <span>Onayla</span>
                <small>Cihaz iade kargolarına eklenecek</small>
              </button>
              <button
                type="button"
                className="cihaz-onayla-action-btn cihaz-onayla-btn-cancel"
                onClick={() => handleActionSelect('iptal')}
                disabled={loading}
              >
                <i className="fas fa-times-circle"></i>
                <span>İptal Et</span>
                <small>Talep iptal edilecek</small>
              </button>
            </div>
          ) : (
            <div className="cihaz-onayla-confirm-box">
              <div className={`cihaz-onayla-confirm-icon ${action}`}>
                <i className={action === 'onayla' ? 'fas fa-box-open' : 'fas fa-ban'}></i>
              </div>
              <p className="cihaz-onayla-confirm-text">
                {action === 'onayla'
                  ? 'Cihaz iade kargolarına eklenecek. Bu işlemi onaylıyor musunuz?'
                  : 'Talep iptal edilecek. Bu işlemi onaylıyor musunuz?'}
              </p>
              {error && (
                <div className="cihaz-onayla-modal-error" role="alert">
                  {error}
                </div>
              )}
              <div className="cihaz-onayla-confirm-actions">
                <button
                  type="button"
                  className={`btn cihaz-onayla-confirm-btn ${action === 'onayla' ? 'btn-primary' : 'btn-danger'}`}
                  onClick={handleConfirm}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <i className="fas fa-spinner fa-spin" style={{ marginRight: 8 }}></i>
                      İşleniyor...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-check" style={{ marginRight: 8 }}></i>
                      {action === 'onayla' ? 'Evet, Onayla' : 'Evet, İptal Et'}
                    </>
                  )}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => { setAction(null); setError(''); }}
                  disabled={loading}
                >
                  Geri
                </button>
              </div>
            </div>
          )}
        </div>
        {!action && (
          <div className="cihaz-onayla-modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Vazgeç
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CihazDegisimiOnaylaModal;
